import * as React from 'react';
import { useAppointmentContext } from '../pages/BookAppointment/context/AppointmentContext.js';
import useVirtualAppointment from '../pages/BookAppointment/hooks/use-virtual-appointment.js';

const useDataLayerInput = ()=>{
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [, { timeSlot , type , store  }] = useAppointmentContext();
    return React.useMemo(()=>{
        return {
            store: store && !isVirtualAppointmentType(type) ? store : undefined,
            appointment: type ? {
                appointmentType: {
                    id: type.id,
                    isVirtualAppointment: isVirtualAppointmentType(type),
                    ageGroup: type.ageGroup
                },
                startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
            } : undefined
        };
    }, [
        isVirtualAppointmentType,
        store,
        timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
        timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until,
        type
    ]);
};
var useDataLayerInput$1 = useDataLayerInput;

export { useDataLayerInput$1 as default };
//# sourceMappingURL=use-data-layer-input.js.map
